/**
 * Specifies the linear gauge constant value
 */
/** @private */
export const loaded = 'loaded';
/** @private */
export const load = 'load';
/** @private */
export const animationComplete = 'animationComplete';
/** @private */
export const axisLabelRender = 'axisLabelRender';
/** @private */
export const tooltipRender = 'tooltipRender';
/** @private */
export const annotationRender = 'annotationRender';
/** @private */
export const gaugeMouseMove = 'gaugeMouseMove';
/** @private */
export const gaugeMouseLeave = 'gaugeMouseLeave';
/** @private */
export const gaugeMouseDown = 'gaugeMouseDown';
/** @private */
export const gaugeMouseUp = 'gaugeMouseUp';
/** @private */
export const dragStart = 'dragStart';
/** @private */
export const dragMove = 'dragMove';
/** @private */
export const dragEnd = 'dragEnd';
/** @private */
export const valueChange = 'valueChange';
/** @private */
export const resized = 'resized';
/** @private */
export const beforePrint = 'beforePrint';
